module.exports = __webpack_public_path__ + "static/media/readme.241d4153.png";